import emailjs from '@emailjs/browser';

// EmailJS Credentials for Feedback/Report/Other - All hardcoded except private key
const FEEDBACK_PUBLIC_KEY = 'EwoOaWHnT8FDDbIGB'; // Hardcoded public key for feedback/reports
const FEEDBACK_SERVICE_ID = 'service_weqwu7c'; // Hardcoded service ID for feedback/reports
const FEEDBACK_TEMPLATE_ID = 'template_zi6hlra'; // Hardcoded template ID for feedback/bug reports/image reports

export interface EmailParams {
    type: string;
    userEmail?: string;
    data: any;
    clientInfo?: any;
}

export const SendEmailService = {
    send: async ({ type, userEmail, data, clientInfo }: EmailParams) => {
        try {
            const defaultValue = "Value not found";

            const now = new Date();
            const monthNames = [
                'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
                'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
            ];
            const submittedAt = `${now.getDate()} ${monthNames[now.getMonth()]} ${now.getFullYear()}`;

            // Prepare template parameters matching the EmailJS template
            const templateParams = {
                type: type || defaultValue,
                from_email: userEmail || "Anonymous",
                submitted_at: submittedAt,
                rating: data?.rating ?? defaultValue,
                category: data?.category || (data?.tags && data.tags.length > 0 ? data.tags.join(", ") : defaultValue),
                description: data?.description || data?.feedback || data?.reportText || defaultValue,
                image_url: data?.imageUrl || data?.displayUrl || defaultValue,
                trigger_source: data?.triggerSource || defaultValue,
                message: JSON.stringify(data, null, 2) || defaultValue,
                user_agent: clientInfo?.userAgent || navigator.userAgent || defaultValue,
                platform: clientInfo?.platform || (navigator as any).platform || defaultValue,
                language: clientInfo?.language || navigator.language || defaultValue,
                timezone: clientInfo?.timezone || Intl.DateTimeFormat().resolvedOptions().timeZone || defaultValue,
                referrer: clientInfo?.referrer || document.referrer || "direct",
            };

            const response = await emailjs.send(
                FEEDBACK_SERVICE_ID,
                FEEDBACK_TEMPLATE_ID,
                templateParams,
                FEEDBACK_PUBLIC_KEY
            );

            return { success: true, detail: response.text };
        } catch (error: any) {
            console.error("[SendEmailService] Error:", error);
            throw new Error(error?.text || error?.message || "Failed to send email");
        }
    },

    sendWaitlist: async ({ email, created_date, created_time, ip }: { email: string; created_date?: string; created_time?: string; ip?: string; }) => {
        try {
            const defaultValue = "Value not found";
            const now = new Date();
            const monthNames = [
                'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
                'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
            ];
            const submittedAt = `${now.getDate()} ${monthNames[now.getMonth()]} ${now.getFullYear()}`;

            // Route waitlist through the same EmailJS service/template used for feedback/report.
            // This avoids "service id not found" issues caused by mismatched service/template ownership.
            const templateParams = {
                type: 'Waitlist',
                from_email: email || "Anonymous",
                submitted_at: submittedAt,
                rating: defaultValue,
                category: 'waitlist',
                description: `Waitlist request from ${email}`,
                image_url: defaultValue,
                trigger_source: 'Waitlist',
                message: JSON.stringify({ email, created_date, created_time, ip }, null, 2),
                user_agent: navigator.userAgent || defaultValue,
                platform: (navigator as any).platform || defaultValue,
                language: navigator.language || defaultValue,
                timezone: Intl.DateTimeFormat().resolvedOptions().timeZone || defaultValue,
                referrer: document.referrer || "direct",
            };

            const response = await emailjs.send(
                FEEDBACK_SERVICE_ID,
                FEEDBACK_TEMPLATE_ID,
                templateParams,
                FEEDBACK_PUBLIC_KEY
            );

            return { success: true, detail: response.text };
        } catch (error: any) {
            console.error("[SendEmailService] Waitlist Error:", error);
            throw new Error(error?.text || error?.message || "Failed to send waitlist email");
        }
    },
};
